<template xmlns:v-on="http://www.w3.org/1999/xhtml">
	<div>
			<headlink></headlink>
		<div class="hello">
			<!--<header class="header ui-header-positive ui-border-b" style="padding:0 210px">
				<ul class="ui-tiled">
					<div><img src="/static/img/logo.png" /> </div>
					<router-link to="/devicemanage" tag="li" class="active">
						<div>设备控制</div>
					</router-link>
					<router-link to="/addDevice" tag="li">
						<div>添加设备</div>
					</router-link>
					<router-link to="/userManage" tag="li">
						<div>用户管理</div>
					</router-link>
					<router-link to="/msgLog" tag="li">
						<div>消息记录</div>
					</router-link>
					<router-link to="/send" tag="li">
						<div>指令群发</div>
					</router-link>
					<router-link to="/baidu" tag="li">
						<div>地图位置</div>
					</router-link>
					<router-link to="/this" tag="li">
						<div>个人信息</div>
					</router-link>

					<li v-on:click="logOut()">
						<div>退出</div>
					</li>
				</ul>
			</header>-->
		
		<center>
			<!--	<form role="form">-->
           <div id="dianlu" >
                 	<h2><span >请先选则电路</span></h2>
                
                 <div v-for="obj in list3" >
                 	
                  	 <h2><input type="checkbox" name="dianlu" v-bind:value="obj.citId" id="quanxuan" />{{obj.citName}}</input>
                   <div>{{obj.citTmDesc}}</div></h2>
                 </div>
                </div>
           




			<h2><span>请选则定时类型</span></h2>
			<select id="leixing" v-on:change="dianji" class="je-select">

				<option>周期定时</option>
				<option>单次定时</option>
				<option>周期循环</option>
				<option>循环定时</option>
				<option>立即循环</option>
				<option>取消定时</option>
				
			</select>
			<div class="alert alert-success alert-dismissable" id="ok" style="display: none;">

			</div>
			<div id="no" style="display: none;" class="alert alert-danger alert-dismissable">

			</div>






			<!--<table class=".table-condensed" id="dl">

				<thead>
					<tr>

						&nbsp;
						<h2><span class="label label-this">请选择电路</span></h2>

					</tr>
				</thead>
				<tbody>
					<tr>
						<td><input type="checkbox" name="dianlu" value="全选" id="quanxuan" /></td>
						<h3><td>全选</td></h3>

					</tr>
					<tr>
						<td><input type="checkbox" class="lv" name="dianlu" value="第一路" checked="checked" /></td>
						<h3><td>第一路</td></h3>

					</tr>
					<tr>
						<td><input type="checkbox" class="lv" name="dianlu" value="第二路" /></td>
						<h3><td>第二路</td></h3>

					</tr>
					<tr v-if="eqType==8 || eqType==10  ">
						<td><input type="checkbox" class="lv" name="dianlu" value="第三路" /></td>
						<h3><td>第三路</td></h3>
					</tr>
					<tr v-if="eqType==8 || eqType==10">
						<td><input type="checkbox" class="lv" name="dianlu" value="第四路" /></td>
						<h3><td>第四路</td></h3>
					</tr>
					<tr v-if="eqType==8">
						<td><input type="checkbox" class="lv" name="dianlu" value="第五路" /></td>
						<h3><td>第五路</td></h3>
					</tr>
					<tr v-if="eqType==8">
						<td><input type="checkbox" class="lv" name="dianlu" value="第六路" /></td>
						<h3><td>第六路</td></h3>
					</tr>
					<tr v-if="eqType==8">
						<td><input type="checkbox" class="lv" name="dianlu" value="第七路" /></td>
						<h3><td>第七路</td></h3>
					</tr>
					<tr v-if="eqType==8">
						<td><input type="checkbox" class="lv" name="dianlu" value="第八路" /></td>
						<h3><td>第八路</td></h3>
					</tr>
				</tbody>
			</table>-->

			<div id="quxiaodingshi" class="bs-example" style="display: none;">
					<button type="button" id="all" class="je-btn je-bg-red je-rdu" >确定</button>
				</div>

			<!--</form>-->
		</center>
		<br><br><br>

		<div id="ljxhdiv" style="display: none;">
			<center>

				<div class="alert alert-success">立即循环使用说明 : 设置开一段时间和关一段时间交替进行，并立刻执行。 例如：立刻执行开5分钟关5分钟交替进行
				</div>

				<div>
					<center>
						<div align="center" class="jz">
							<h3><b>开启时长 : &nbsp;&nbsp;<input class="dateinput dateicon" type="text"  id="ljxhontime" value=""></b></h3></div>
					</center>
				</div><br>
				<div>
					<center>
						<div align="center" id="jz">
							<h3><b>关闭时长 : &nbsp;&nbsp;<input class="dateinput dateicon" type="text"  id="ljxhofftime" value=""></b></h3></div>
					</center>
				</div><br>

				<h3>
      	
      		   
                 <input type="button" value="确定" class="je-btn je-bg-red je-rdu" id="ljxh" />
                 
      	
        </center>
    </div>  






		<div id="zqxhdiv" style="display: none;">
			<center>

			<div class="alert alert-success">周期循环使用说明 : 设置一段时间，在这个时间段内循环交替开一段时间，关一段时间。例如：08:30:30到08:30:30内，开5分钟，关5分钟</div>
			
				
					
						<div>
							<div><h3><b>开始时间 :  &nbsp;&nbsp;<input class="dateinput dateicon" type="text"  id="stime" value=""></b></h3></div>

	</div><br>
	<div>
		<div>
			<h3><b>結束时间 : &nbsp;&nbsp;<input class="dateinput dateicon" type="text"  id="etime" value=""></b></h3></div>

	</div><br>
	<div>
		<div>
			<h3><b>开启时长 :  &nbsp;&nbsp;<input class="dateinput dateicon" type="text"  id="ontime" value=""></b></h3></div>

	</div><br>
	<div>
		<div>
			<h3><b>关闭时长 :  &nbsp;&nbsp;<input class="dateinput dateicon" type="text"  id="offtime" value=""></b></h3></div>

	</div><br>

	<table cellpadding="10px" cellspacing="10px">
		<tr>
			<td>
				<h3>重复&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h3></td>
			<td>
				<h3> 
                       
             

				<ul>

	<li><input type="checkbox"  name="zqxh"   value="1" />星期一</li>

	<li><input type="checkbox" name="zqxh" value="2" />星期二</li>

	<li><input type="checkbox" name="zqxh"  value="3" />星期三</li>

	<li><input type="checkbox"  name="zqxh"  value="4" />星期四</li>

	<li><input type="checkbox" name="zqxh"   value="5" />星期五</li>

	<li><input type="checkbox"  name="zqxh"  value="6" />星期六</li>

	<li><input type="checkbox"  name="zqxh"  value="7" />星期日</li>

</ul>

	
	
	
 </h3> </td>
		</tr>
	</table>

	<h3>
      	
      		 
                 <input type="button" value="确定"  class="je-btn je-bg-red je-rdu" id="zqxh" />
               
        </center>
    </div>  
		
		
		
		
		 <div id="dcdsdiv" style="display: none;">      
	<center>
		
		<div class="alert alert-success">单次定时使用说明 : 添加日历中具体某一天某一时刻定时。例如：10月10日18:30:30开</div>
		
		
		
	  
		<div>
			<div><h3><b>日期 : &nbsp;&nbsp;<input class="dateinput dateicon" type="text" id="riqi"></b></h3> </div>
	</div><br>
	<div>
		<div>
			<h3><b>时间  :  &nbsp;&nbsp;<input class="dateinput dateicon" type="text" id="dcdsstime" value=""></b></h3> </div>
	</div><br>

	<h3><input  type="radio" name="dcds" checked="checked" value="1"/>开    
                   <input  type="radio" name="dcds" value="0" />关 </h3>
	<div>
		<input type="button" value="确定" class="je-btn je-bg-red je-rdu" id="dcds" />
		
	</div>

	</center>
	</div>

	<div id="xhdsdiv" style="display: none;">
		<center>
			<div class="alert alert-success">循环定时使用说明 : 设置一段时间，在第一个时间点自动开启，第二个时间点自动关闭。例如： 18:30:30开06:30:30关。(如果设备当前时间已经超过开启或者关闭时间，设备将在下次时间到来时执行)
			</div>

			<div>
				<div>
					<h3><b>开始时间 : &nbsp;&nbsp;<input class="dateinput dateicon" type="text"  id="xhdsstime" value=""></b></h3></div>

			</div><br>
			<div>
				<div>
					<h3><b>结束时间 : &nbsp;&nbsp;<input class="dateinput dateicon" type="text"  id="xhdsetime" value=""></b></h3></div>

			</div><br>

			<table cellpadding="10px" cellspacing="10px">
				<tr>
					<td>
						<h3>重复&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h3></td>
					<td>
						<h3> 
  
	
	<ul>

	<li><input type="checkbox"  name="xhds"   value="1" />星期一</li>

	<li><input type="checkbox" name="xhds" value="2" />星期二</li>

	<li><input type="checkbox" name="xhds"  value="3" />星期三</li>

	<li><input type="checkbox"  name="xhds"  value="4" />星期四</li>

	<li><input type="checkbox" name="xhds"   value="5" />星期五</li>

	<li><input type="checkbox"  name="xhds"  value="6" />星期六</li>

	<li><input type="checkbox"  name="xhds"  value="7" />星期日</li>

 </ul>
	
	
	
 </h3> </td>
				</tr>
			</table>

			<h3>
      	
      		  
                 <input type="button" value="确定" class="je-btn je-bg-red je-rdu" id="xhds" />
               
      	
        
        
       
       
       
        </center>
    </div> 
		
		
		
		
		
		
		
		
		
		
		
		
		
		
		
		
		
		  <div id="zqdsdiv" style="display: block;">    
	<center>
    <div class="alert alert-success">周期定时使用说明 : 设置一个时间在该时间重复定时。例如：每周六18:30:30开</div>
　　  </center>
	
	<center>
	<div class="alert alert-success alert-dismissable" id="ok" style="display: none;">
         
         
        </div>
      <div id="no" style="display: none;" class="alert alert-danger alert-dismissable">

			</div>
        
        
        
	</center>
	<center>
	
		
	 
		  <div>
			<div><h3><b>时间: &nbsp;&nbsp;<input  class="dateinput dateicon" type="text"  id="zqdsstime" value=""></b></h3></div>
	</div>

	<table cellpadding="10px" cellspacing="10px">
		<tr>
			<td>
				<h3>重复&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h3></td>
			<td>
				<h3> 
  
  <ul>

	<li><input type="checkbox"  name="zqds"   value="1" />星期一</li>

	<li><input type="checkbox"  name="zqds" value="2" />星期二</li>

	<li><input type="checkbox"  name="zqds"  value="3" />星期三</li>

	<li><input type="checkbox"   name="zqds"  value="4" />星期四</li>

	<li><input type="checkbox"  name="zqds"   value="5" />星期五</li>

	<li><input type="checkbox"   name="zqds"  value="6" />星期六</li>

	<li><input type="checkbox"   name="zqds" value="7" />星期日</li>

 </ul>
 
	 
	
	
 </h3> </td>
		</tr>
	</table>

	<h3><input  type="radio" name="kg" checked="checked" value="1"/>开
             
                  <input  type="radio" name="kg" value="0" />关</h3>
	<div><input type="button" value="确定" class="je-btn je-bg-red je-rdu" id="zqds" />
		</div>

	</center>
	</div>
</div>
	</div>

</template>

<script>
	import headlink from '@/components/common/headlink'

	export default {
		name: 'info',
		data() {
			return {
				hours: "",
				minutes: "",
				seconds: "",
				eqType: this.$route.params.eqType,
				list3:[],
				list4:[],
				eqObject:{}
			}
		},

		mounted: function() {
         const history = window.sessionStorage;
			var uid = history.getItem("user");
			var eqId = this.$route.params.eqId;

			var params1={
			"serviceCode": "1018",
					"uId": uid,
					eqId: eqId
			}
			$.ajax({
				type:"post",
				url:"http://localhost:8080/ZYun/HttpService.do",
				async:true,
				data: JSON.stringify(params1),
					dataType: 'json',
					success : (data)=> {
						if(data.respCode == '0000') {
							this.eqObject = data;
						    this.list3 = [];
							this.list4 = [];
							for(var cit of this.eqObject.citList) {
								//						如果word1是0，就是电路 否则就是端口
								var word1 = cit.citType.substring(0, 1);
								var word2 = cit.citType.substring(1, 2);
								var i = parseInt(word2) - 1;
								if(word1 == "0") {
									this.list3[i] = cit;
								} else {
									this.list4[i] = cit;

								}
							}
                                console.log(this.list3)
						}
						
						
					}
			});
			
			//			    zqdsstime
			jeDate("#dcdsstime", {
				isinitVal: true,
				festival: true,
				format: "hh:mm:ss"
			});
			jeDate("#riqi", {
				isinitVal: true,
				festival: true,
				format: 'YYYY/MM/DD'
			});
			jeDate("#zqdsstime", {
				isinitVal: true,
				festival: true,
				format: "hh:mm:ss"
			});
			jeDate("#stime", {
				isinitVal: true,
				festival: true,
				format: "hh:mm:ss"
			});
			jeDate("#etime", {
				isinitVal: true,
				festival: true,
				format: "hh:mm:ss"
			});
			jeDate("#ontime", {
				isinitVal: true,
				festival: true,
				format: "hh:mm:ss"
			});
			jeDate("#offtime", {
				isinitVal: true,
				festival: true,
				format: "hh:mm:ss"
			});
			jeDate("#xhdsstime", {
				isinitVal: true,
				festival: true,
				format: "hh:mm:ss"
			});
			jeDate("#xhdsetime", {
				isinitVal: true,
				festival: true,
				format: "hh:mm:ss"
			});
			jeDate("#ljxhontime", {
				isinitVal: true,
				festival: true,
				format: "hh:mm:ss"
			});
			jeDate("#ljxhofftime", {
				isinitVal: true,
				festival: true,
				format: "hh:mm:ss"
			});

			var date = new Date();
			this.hours = date.getHours();
			this.minutes = date.getMinutes();
			this.seconds = date.getSeconds();
			if(this.hours < 10) {
				this.hours = "0" + this.hours;
			}
			if(this.minutes < 10) {
				this.minutes = "0" + this.minutes;
			}
			if(this.seconds < 10) {
				this.seconds = "0" + this.seconds;
			}
			$("#dcdsstime").val(this.hours + ":" + this.minutes + ":" + this.seconds);
			$("#zqdsstime").val(this.hours + ":" + this.minutes + ":" + this.seconds);
			$("#stime").val(this.hours + ":" + this.minutes + ":" + this.seconds);
			$("#etime").val(this.hours + ":" + this.minutes + ":" + this.seconds);
			$("#ontime").val(this.hours + ":" + this.minutes + ":" + this.seconds);
			$("#offtime").val(this.hours + ":" + this.minutes + ":" + this.seconds);
			$("#xhdsetime").val(this.hours + ":" + this.minutes + ":" + this.seconds);
			$("#xhdsstime").val(this.hours + ":" + this.minutes + ":" + this.seconds);
			$("#ljxhontime").val(this.hours + ":" + this.minutes + ":" + this.seconds);
			$("#ljxhofftime").val(this.hours + ":" + this.minutes + ":" + this.seconds);

			$("#quanxuan").click(function() { //给全选按钮加上点击事件
				var xz = $(this).prop("checked"); //判断全选按钮的选中状态
				var ck = $(".lv").prop("checked", xz); //让class名为qx的选项的选中状态和全选按钮的选中状态一致。  
			})

			

			var dianlus = [];
			$.each($('input[name="dianlu"]:checked'), function() {

				dianlus.push($(this).val());

			});
            console.log("选择的电路有"+dianlus);
			if(dianlus.length != "0") {

				
				//	var dianlus = $("select").val();
				var leixing = $("#leixing option:selected");

//				function getdata() {
//
//					if(eqId.length == 9) {
//						eqId = "0" + eqId
//					}
//
//					var json = {
//						"serviceCode": "1018",
//						"uId": uid,
//						"eqId": eqId
//					}
//					return json;
//				}
				$.ajax({
					type: "post",
					url: "http://localhost:8080/ZYun/HttpService.do",
					contentType: "application/json; charset=utf-8",
					async: true,
					data: JSON.stringify(getdata()),
					dataType: 'json',
					success: function(e) {

						if(leixing.val() == "周期定时") {

							var dstype = "A";
							$("#zqdsdiv").show()
							$("#dcdsdiv").hide()
							$("#zqxhdiv").hide()
							$("#xhdsdiv").hide()
							$("#ljxhdiv").hide()

							$("#zqdsexit").click(function() {
								$("#zqdsdiv").hide()

							})

							$("#zqds").click(function() {

								$.ajax({
									type: "post",
									url: "http://localhost:8080/ZYun/HttpService.do",
									contentType: "application/json; charset=utf-8",
									async: true,
									data: JSON.stringify(zqdsData()),
									dataType: 'json',
									success: function(e) {
										if("0000" == e.respCode) {
											jeBox.msg('周期定时成功！', {
												icon: 2,
												time: 3
											});

										} else {

											jeBox.msg('周期定时失败！', {
												icon: 3,
												time: 3
											});

										}

									}
								});

								function zqdsData() {

									var on_off = $('input[name="kg"]:checked').val();

									var zqdsweek = [];
									$('input[name=zqds]:checked').each(function() {

										zqdsweek.push($(this).val());

									});
                           console.log("---------------dsfa------"+zqdsweek.toString());
                           console.log(typeof(zqdsweek));
                           console.log(typeof(zqdsweek.toString()));
									var stime = $("#zqdsstime").val();
									var rs = new RegExp(":", "g");
									stime = stime.replace(rs, "");

									var json = {
										"serviceCode": "1025",
										"uId": uid,
										"eqId": eqId,
										"type": dstype,
										"weeks": zqdsweek.toString(),
										"on_off": on_off,
										"citIds": dianlus + "",
										"startTime": stime
									}
									return json;
								}

							})

						}
					}
				})
			}

		},
		methods: {
			dianji: function() {
				const history = window.sessionStorage;
				var uid = history.getItem("user");
				var eqId = this.$route.params.eqId;

				var dianlus = [];
				$.each($('input[name="dianlu"]:checked'), function() {

					dianlus.push($(this).val());

				});
                 console.log("选择的电路有"+dianlus)
				if(dianlus.length != "0") {

					
					//	var dianlus = $("select").val();
			var leixing = $("#leixing option:selected");
					
                       if(leixing.val() == "周期定时") {

								var dstype = "A";
								$("#quxiaodingshi").hide()
								$("#zqdsdiv").show()
								$("#dcdsdiv").hide()
								$("#zqxhdiv").hide()
								$("#xhdsdiv").hide()
								$("#ljxhdiv").hide()

								$("#zqdsexit").click(function() {
									$("#zqdsdiv").hide()

								})

								$("#zqds").click(function() {

									$.ajax({
										type: "post",
										url: "http://localhost:8080/ZYun/HttpService.do",
										contentType: "application/json; charset=utf-8",
										async: true,
										data: JSON.stringify(zqdsData()),
										dataType: 'json',
										success: function(e) {
											if("0000" == e.respCode) {
												jeBox.msg('周期定时成功！', {
													icon: 2,
													time: 3
												});

											} else {

												jeBox.msg('周期定时失败！', {
													icon: 3,
													time: 3
												});

											}

										}
									});

									function zqdsData() {

								var on_off = $('input[name="kg"]:checked').val();

										var zqdsweek = [];
										$('input[name=zqds]:checked').each(function() {

											zqdsweek.push($(this).val());

										});
                            console.log("-----------"+zqdsweek);
										var stime = $("#zqdsstime").val();
										var rs = new RegExp(":", "g");
										stime = stime.replace(rs, "");

										var json = {
											"serviceCode": "1025",
											"uId": uid,
											"eqId": eqId,
											"type": dstype,
											"weeks": zqdsweek.toString(),
											"on_off": on_off,
											"citIds": dianlus + "",
											"startTime": stime
										}
										return json;
									}

								})

							} else if(leixing.val() == "单次定时") {
								var dstype = "B";
								$("#quxiaodingshi").hide()
								$("#dcdsdiv").show()
								$("#zqdsdiv").hide()
								$("#zqxhdiv").hide()
								$("#xhdsdiv").hide()
								$("#ljxhdiv").hide()

								$("#dcdsexit").click(function() {
									$("#dcdsdiv").hide()

								})

								$("#dcds").click(function() {

									$.ajax({
										type: "post",
										url: "http://localhost:8080/ZYun/HttpService.do",
										contentType: "application/json; charset=utf-8",
										async: true,
										data: JSON.stringify(dcdsData()),
										dataType: 'json',
										success: function(e) {
											if("0000" == e.respCode) {
												jeBox.msg('单次定时成功！', {
													icon: 2,
													time: 3
												});

											} else {
												jeBox.msg('单次定时失败！', {
													icon: 3,
													time: 3
												});

											}

										}
									});

									function dcdsData() {
										var on_off = $('input[name="dcds"]:checked').val();
										var stime = $("#dcdsstime").val();
										var riqi = $("#riqi").val();
										var re = new RegExp("/", "g");
										var rs = new RegExp(":", "g");
										riqi = riqi.replace(re, "");

										stime = stime.replace(rs, "");

										var json = {
											"serviceCode": "1025",
											"uId": uid,
											"eqId": eqId,
											"type": dstype,
											"on_off": on_off,
											"date": riqi,
											"citIds": dianlus + "",
											"startTime": stime
										}
										return json;
									}

								})

							} else if(leixing.val() == "周期循环") {
								var dstype = "C";
								$("#quxiaodingshi").hide()
								$("#zqxhdiv").show()
								$("#zqdsdiv").hide()
								$("#dcdsdiv").hide()
								$("#xhdsdiv").hide()
								$("#ljxhdiv").hide()
								$("#zqxhexit").click(function() {
									$("#zqxhdiv").hide()

								})

								$("#zqxh").click(function() {

									$.ajax({
										type: "post",
										url: "http://localhost:8080/ZYun/HttpService.do",
										contentType: "application/json; charset=utf-8",
										async: true,
										data: JSON.stringify(zqxhdata()),
										dataType: 'json',
										success: function(e) {
											if("0000" == e.respCode) {
												jeBox.msg('周期循环成功！', {
													icon: 2,
													time: 3
												});
											} else {
												jeBox.msg('周期循环失败！', {
													icon: 3,
													time: 3
												});

											}
										}
									});

									function zqxhdata() {

										var etime = $("#etime").val();
										var stime = $("#stime").val();
										var ontime = $("#ontime").val();
										var offtime = $("#offtime").val();
										

										var rs = new RegExp(":", "g");

										etime = etime.replace(rs, "");
										stime = stime.replace(rs, "");
										ontime = ontime.replace(rs, "");
										offtime = offtime.replace(rs, "");
										var zqxhweek = [];
										$('input[name=zqxh]:checked').each(function() {

											zqxhweek.push($(this).val());

										});

										console.log(zqxhweek);
										
										var json = {
											"serviceCode": "1025",
											"uId": uid,
											"eqId": eqId,
											"type": dstype,
											"weeks": zqxhweek.toString(),
											"citIds": dianlus + "",
											"startTime": stime,
											"endTime": etime,
											"openLength": ontime,
											"closeLength": offtime
										}
										return json;
									}
								})
							} else if(leixing.val() == "循环定时") {
								var dstype = "D";
								$("#quxiaodingshi").hide()
								$("#xhdsdiv").show()
								$("#zqdsdiv").hide()
								$("#dcdsdiv").hide()
								$("#zqxhdiv").hide()
								$("#ljxhdiv").hide()
								$("#xhdsexit").click(function() {
									$("#xhdsdiv").hide()

								})

								$("#xhds").click(function() {

									$.ajax({
										type: "post",
										url: "http://localhost:8080/ZYun/HttpService.do",
										contentType: "application/json; charset=utf-8",
										async: true,
										data: JSON.stringify(xhdsData()),
										dataType: 'json',
										success: function(e) {
											if("0000" == e.respCode) {
												jeBox.msg('循环定时成功！', {
													icon: 2,
													time: 3
												});
											} else {
												jeBox.msg('循环定时失败！', {
													icon: 3,
													time: 3
												});

											}

										}
									});

									function xhdsData() {
										var stime = $("#xhdsstime").val();
										var etime = $("#xhdsetime").val();
										var rs = new RegExp(":", "g");

										etime = etime.replace(rs, "");
										stime = stime.replace(rs, "");

										var xhdsweek = [];
										$('input[name=xhds]:checked').each(function() {

											xhdsweek.push($(this).val());

										});

										var json = {
											"serviceCode": "1025",
											"uId": uid,
											"eqId": eqId,
											"type": dstype,
											"weeks": xhdsweek.toString(),
											"citIds": dianlus + "",
											"startTime": stime,
											"endTime": etime
										}
										return json;
									}

								})

							} else if(leixing.val() == "立即循环") {
								var dstype = "E";
								$("#quxiaodingshi").hide()
								$("#ljxhdiv").show()
								$("#zqdsdiv").hide()
								$("#dcdsdiv").hide()
								$("#zqxhdiv").hide()
								$("#xhdsdiv").hide()
								$("#ljxhexit").click(function() {
									$("#ljxhdiv").hide()

								})

								$("#ljxh").click(function() {

									$.ajax({
										type: "post",
										url: "http://localhost:8080/ZYun/HttpService.do",
										contentType: "application/json; charset=utf-8",
										async: true,
										data: JSON.stringify(ljxhData()),
										dataType: 'json',
										success: function(e) {
											if("0000" == e.respCode) {
												jeBox.msg('立即循环成功！', {
													icon: 2,
													time: 3
												});
											} else {
												jeBox.msg('立即循环失败！', {
													icon: 3,
													time: 3
												});
											}

										}
									});

									function ljxhData() {

										var ontime = $("#ljxhontime").val();
										var offtime = $("#ljxhofftime").val();

										var rs = new RegExp(":", "g");

										ontime = ontime.replace(rs, "");
										offtime = offtime.replace(rs, "");

										var json = {
											"serviceCode": "1025",
											"uId": uid,
											"eqId": eqId,
											"type": dstype,
											"citIds": dianlus + "",
											"openLength": ontime,
											"closeLength": offtime
										}
										return json;
									}

								})

							} else if(leixing.val() == "取消定时") {
								$("#quxiaodingshi").show()
								$("#ljxhdiv").hide()
								$("#zqdsdiv").hide()
								$("#dcdsdiv").hide()
								$("#zqxhdiv").hide()
								$("#xhdsdiv").hide()
							
						$("#all").click(function(){
							
							var dstype = "F";
								$.ajax({
									type: "post",
									url: "http://localhost:8080/ZYun/HttpService.do",
									contentType: "application/json; charset=utf-8",
									async: true,
									data: JSON.stringify(getqxdsData()),
									dataType: 'json',
									success: function(e) {
										if("0000" == e.respCode) {

											jeBox.msg('取消定时成功！', {
												icon: 2,
												time: 3
											});

										} else {
											jeBox.msg('取消定时失败！', {
												icon: 3,
												time: 3
											});
										}
									}
								});

								function getqxdsData() {

									var json = {
										"serviceCode": "1025",
										"uId": uid,
										"eqId": eqId,
										"citIds": dianlus + "",
										"type": dstype

									}
									return json;
								}
							
							
							
							
						})
						
				} 

					


				} else {
					jeBox.msg('请先选择电路！', {
						icon: 2,
						time: 3
					});
				}

			}

		},
		
	
		components: {
			headlink: headlink
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="../../../static/css/index.css">

</style>-->-->


// WEBPACK FOOTER //
// src/components/devicemanage/dingshi.vue